import { CalendarToday, HeadsetMic, People } from "@mui/icons-material";
import { Avatar, Box, Button, Dialog, Grid, Paper, Stack } from "@mui/material";
import { useState } from "react";
import { formatDate } from "../../utils/dateTimeFormat";
import { TableAvatar } from "../../utils/dataGrid";
import ReviewPreliminaryBookingDialog from "./dialogs/ReviewPreliminaryBookingDialog";
import Translate from "../../utils/Translate";

export default function PreliminaryBooking({ bookingRequest, courseId, onChange }) {
  const [dialogOpen, setDialogOpen] = useState(false);

  async function handleReviewDialogClose(changed) {
    setDialogOpen(false);
    if (changed) {
      onChange();
    }
  }

  return (
    <Box sx={{ width: "100%", mt: 1 }}>
      {dialogOpen && (
        <ReviewPreliminaryBookingDialog
          bookingRequest={bookingRequest}
          courseId={courseId}
          onClose={handleReviewDialogClose}
        />
      )}
      <Paper className="stdBoxShadow" sx={{ width: "100%", mb: 2, padding: "18px" }}>
        <Grid container width="100%" alignItems="center" spacing={{ xs: 2.5, md: 0 }}>
          <Grid
            container
            size={{ xs: 12, sm: 6, md: 3.73 }}
            alignItems="center"
            spacing={1.2} /*sx={{ paddingLeft: "42px" }}*/
          >
            <Grid>
              <Avatar>{bookingRequest.companyName?.[0]?.toUpperCase()}</Avatar>
            </Grid>
            <Grid>
              <div className="tableAvatarTitle bold">{bookingRequest.companyName}</div>
            </Grid>
          </Grid>

          <Grid
            container
            size={{ xs: 12, sm: 6, md: 2.59 }}
            alignItems="center"
            spacing={1.2}
            paddingLeft={{ xs: "17px", sm: 0 }}
          >
            <Grid>
              <HeadsetMic />
            </Grid>
            <Grid>
              <TableAvatar
                hideImage
                title={bookingRequest.contactName}
                subtitle={[<a href={"mailto:" + bookingRequest.contactEmail}>{bookingRequest.contactEmail}</a>]}
              />
            </Grid>
          </Grid>

          <Grid
            container
            size={{ xs: 12, sm: 6, md: 2.57 }}
            alignItems="center"
            spacing={1.2}
            paddingLeft={{ xs: "17px", sm: 0 }}
          >
            <Grid>
              <People />
            </Grid>
            <Grid>{bookingRequest.nbrOfParticipants}</Grid>
          </Grid>

          <Grid
            container
            size={{ xs: 12, sm: 6, md: 1.555 }}
            alignItems="center"
            spacing={1.2}
            paddingLeft={{ xs: "17px", sm: 0 }}
          >
            <Grid>
              <CalendarToday />
            </Grid>
            <Grid>{formatDate(bookingRequest.bookingDate)}</Grid>
          </Grid>

          <Grid size={{ xs: 12, md: 1.555 }}>
            <Stack direction="row" justifyContent={{ xs: "center", md: "flex-end" }}>
              <Button
                sx={{ width: { xs: "100%", md: "auto" } }}
                variant="contained"
                onClick={() => setDialogOpen(true)}
              >
                {Translate.get("ReviewPreliminaryBookingButton")}
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}
